<div class="flex items-center">
  <mat-form-field [ngClass]="disabled ? 'custom-select-disabled' : 'custom-select'" *ngIf="groups.length > 0">
    <mat-select [(value)]="groupSelectedId" [disabled]="disabled" (selectionChange)="onSelectionChanged(groupSelectedId, false)">
      <mat-option *ngFor="let group of groups" [value]="group.id">
        {{ group.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
